<template>
    <div class="right_top_btnsec full-width" style="background: transparent;">
        <div class="row">
            <!-- <div class="col-3">
                <div class="top_logosec pull-left">
                    <router-link :to="'#'"><img src="../../../../static/prism/images/inner_logo.png" alt="#" class="logo_sec" /></router-link>
                </div>
            </div> -->
            
            <div class="col-12 p-2 text-right registrationHeaderNav"> 
                <div class="add_fund ml-2 pull-right">
                    <a title="Chat With Us" href="https://direct.lc.chat/12465924/1" target="_blank()" class="newBtnChatBeforeLogin">
                        <img style="width:15px;margin-top: 9px;" src="../../../../static/prism/images/chat.svg" alt="#" />
                    </a>
                    <a href="#"  @click="logout()" class="pull-right ml-2"> Log Out</a>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>   
    import * as types from '@/types'
    import { mapActions } from 'vuex'  
    import { prismMixins } from '@/plugins/prism'
    export default{
        name: 'PrismApp',
        mixins: [prismMixins],    
        data(){
            return {
            }
        },
        methods:{
            ...mapActions({
                _runLogout: types.RUN_USER_LOGOUT
            }),
            logout(){
                const r = this.$router
                this._runLogout({
                    router: r,
                    parameter: this
                })
            }
        }
    }
</script>
<style>
.newBtnChatBeforeLogin{
    height: 35px;
    width: 35px;
    position: relative;
    background-color: #CE7672;
    text-align: center;
    line-height: 35px;
    border-radius: 50% !important;
    color: #fff;
    display: inline-block;
    top: -4px;
}
.newBtnChatBeforeLogin:hover{color:#fff}
.registrationHeaderNav a{
    font-size: 14px !important;
    border-radius: 8px;
}
.registrationHeaderNav a svg{
    width: 17px;
    margin-top: -2px;
    margin-right: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/prism/shared/RegisterHeader.vue